import React, { useContext, useEffect } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useProjectService from '../../../app/services/hooks/useProjectService';

interface Props {
  projectId: number;
  checkValue: boolean;
  callbackSuccess: () => void;
}

const ProjectSwitchChange = ({ projectId, checkValue, callbackSuccess }: Props) => {
  const { hideLoading } = useContext(AppContext);
  const [checked, setChecked] = React.useState<boolean>(checkValue);
  const { activeProject } = useProjectService();

  useEffect(() => {
    setChecked(checkValue);
  }, [checkValue]);

  const active = (value: boolean) => {
    setChecked(value);
    activeProject(projectId, value, {
      onSuccess: (response: ServiceResponse) => {
        if (hideLoading) hideLoading();
        useReactConfirmAlert().successAlert({
          title: 'Éxito',
          message: response.message
        });
        callbackSuccess();
      },
      onError: (response: ServiceResponse) => {
        if (hideLoading) hideLoading();
        setChecked(!value);
        useReactConfirmAlert().errorAlert({
          title: 'Error',
          message: response.message
        });
      }
    });
  };

  return <ActiveControl status={checked} id={projectId} callback={active} />;
};

export default ProjectSwitchChange;

